"use strict";

module.exports = require("./is-implemented")() ? globalThis : require("./implementation");



//////////////////
// WEBPACK FOOTER
// D:/cpc/sinocc.web/web.X6/www/x6.ng2/~/ext/global-this/index.js
// module id = ../../../../ext/global-this/index.js
// module chunks = 4